import api from '@/api'

const state = {
  recursoCategorias: []
}

const getters = {
  recursoCategorias: (state) => {
    return state.recursoCategorias
  }
}

const mutations = {
  SET_CATEGORIAS_RECURSO(state, recursoCategorias) {
    state.recursoCategorias = recursoCategorias
  }
}

const actions = {
  async fetchCategoriasRecurso({ commit }) {
    try {
      const response = await api.recursoCategoria.getCategoriasRecurso()
      commit('SET_CATEGORIAS_RECURSO', response.data)

    } catch (err) {
      console.error(err)
      throw err
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
